<template>
    <div>
        <Lottery ref="lottery" v-bind="lotteryOptions" :language="language" :lottie-modal-ref="$refs.lottieModal" />
        <DrawResultModal v-model="showDrawResultModal" :draw-result="drawResult" />
        <multiDrawResultModal v-model="showMultiDrawResultModal" :draw-result="multiDrawResult" />
        <multiDrawFailResultModal
            v-model="isMultiDrawFailModalShow"
            :draw-result="multiDrawFailResult"
            @modal-btn-click="failModalBtnClick"
        />
        <LottieModal
            ref="lottieModal"
            v-if="needAnimate"
            v-model="isLotteryModalShow"
            :start-animate-link="startAnimateLink"
            :loop-animate-link="loopAnimateLink"
            :end-animate-link="endAnimateLink"
            :auto-start="false"
        />
    </div>
</template>

<script>
import { common, store } from '@futuweb/fego-render';
const { variable } = store;
import {
    EVENT_NAME,
    REMAIN_COUNT_PLACEHOLDER,
    SUCCESS_DRAW_COUNT_PLACEHOLDER,
    FAIL_DRAW_COUNT_PLACEHOLDER
} from '../constants/business';
import Lottery from './Lottery/index.vue';
import DrawResultModal from './DrawResultModal/index.vue';
import multiDrawResultModal from './multiDrawResultModal/index.vue';
import multiDrawFailResultModal from './multiDrawFailResultModal/index.vue';
import LottieModal from './LottieModal/index.vue';
import Toast from '@futuweb/future-ui/es/toast';
import '@futuweb/future-ui/es/toast/style/css';
import { isH5, isLogin } from '../utils';

export default {
    name: 'lottery2',
    props: {
        language: {
            type: String,
            default: ''
        },
        notLoggedText: {
            type: String,
            default: ''
        },
        hasLoggedText: {
            type: String,
            default: ''
        },
        actConfig: {
            type: Array,
            default: () => []
        },
        remainCountName: {
            type: String,
            default: 'commonLotteryRemain'
        },
        currentCountName: {
            type: String,
            default: 'commonLotteryCurrent'
        },
        // 一键十抽成功弹窗配置
        multiDrawSucTitle: {
            type: String,
            default: ''
        },
        multiDrawSucDesc: {
            type: String,
            default: ''
        },
        multiDrawSucBtnLabel: {
            type: String,
            default: ''
        },
        multiDrawSucBtnUrl: {
            type: String,
            default: ''
        },
        // 一键多抽失败弹窗配置
        multiDrawFailTitle: {
            type: String,
            default: ''
        },
        multiDrawFailDesc: {
            type: String,
            default: ''
        },
        multiDrawFailBtnLabel: {
            type: String,
            default: ''
        },
        multiDrawFailBtnUrl: {
            type: String,
            default: ''
        },
        failCoverUrl: {
            type: String,
            default: ''
        },
        multiDrawCount: {
            type: Number,
            default: 2
        },
        // 抽奖动画配置
        startAnimateLink: {
            type: String,
            default: ''
        },
        loopAnimateLink: {
            type: String,
            default: ''
        },
        endAnimateLink: {
            type: String,
            default: ''
        },
        needAnimate: {
            type: Boolean,
            default: false
        },
        needMultiDraw: {
            type: Boolean,
            default: false
        }
    },
    components: {
        Lottery,
        DrawResultModal,
        multiDrawResultModal,
        multiDrawFailResultModal,
        LottieModal
    },
    data() {
        return {
            isH5: isH5(),
            isLogin,
            drawCountInfo: [],
            showDrawResultModal: false,
            showMultiDrawResultModal: false,
            isMultiDrawFailModalShow: false,
            isLotteryModalShow: false,
            drawResult: {
                title: '',
                cover: '',
                desc: '',
                btnLabel: '',
                btnUrl: ''
            },
            multiDrawResult: {
                title: this.multiDrawSucTitle,
                coverList: [],
                desc: this.multiDrawSucDesc,
                btnLabel: this.multiDrawSucBtnLabel,
                btnUrl: this.multiDrawSucBtnUrl
            },
            multiDrawFailResult: {
                title: this.multiDrawFailTitle,
                coverList: [],
                desc: this.multiDrawFailDesc,
                btnLabel: this.multiDrawFailBtnLabel,
                btnUrl: this.multiDrawFailBtnUrl
            }
        };
    },
    computed: {
        // 总抽奖次数
        drawCount() {
            let remain = 0;
            let current = 0;
            this.drawCountInfo.forEach((item) => {
                remain += item.remain;
                current += item.current;
            });
            return {
                current,
                remain
            };
        },
        // 抽奖配置
        // eslint-disable-next-line max-lines-per-function
        lotteryOptions() {
            const remain = this.drawCount.remain;
            let text = this.notLoggedText;
            if (isLogin) {
                text = this.hasLoggedText.replace(REMAIN_COUNT_PLACEHOLDER, this.drawCount.remain);
            }
            return {
                remain,
                text,
                drawCb: async () => {
                    const res = await this.draw();
                    return res;
                },
                drawSuccessCb: (res) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    if (!res?.prizeKey) {
                        throw new Error('request failed');
                    }
                    let app = null;
                    this.actConfig.some((config) => {
                        // 获取中奖的appKey对应的配置
                        app = config.appGroup.find((item) => item.appKey === res.appKey);
                        return app;
                    });
                    const target = app.prizeList.find((item) => item.prizeKey === res.prizeKey) || {};
                    this.drawResult = {
                        title: target.congratTitle || '',
                        cover: target.congratImgUrl || '',
                        desc: target.congratDesc || '',
                        btnLabel: target.congratBtnLabel || '',
                        btnUrl: target.congratBtnUrl || ''
                    };
                    this.showPrizeModal(target);
                    this.$nextTick(() => {
                        this.$emit(EVENT_NAME.DRAW_SUCCESS, res);
                    });
                },
                drawFailCb: (err) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    console.log(err);
                    Toast.error('The request failed, please refresh and try again');
                    this.$emit(EVENT_NAME.DRAW_FAIL);
                },
                noRemainCb: () => {
                    this.$emit(EVENT_NAME.NO_REMAIN);
                },
                noLoginCb: () => {
                    this.$emit(EVENT_NAME.NO_LOGIN);
                },
                // 一键十抽回调
                multiDrawCb: async () => {
                    const res = await this.multiDraw();
                    return res;
                },
                multiDrawSuccessCb: (res) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    // 获取抽中奖品对应的配置
                    const coverList = this.getCoverList(res);
                    this.multiDrawResult = {
                        title: this.multiDrawSucTitle,
                        desc: this.multiDrawSucDesc,
                        btnLabel: this.multiDrawSucBtnLabel,
                        btnUrl: this.multiDrawSucBtnUrl,
                        coverList
                    };
                    this.showMultiPrizeModal();
                    this.$nextTick(() => {
                        this.$emit(EVENT_NAME.DRAW_SUCCESS, res);
                    });
                },
                multiDrawFailCb: (res) => {
                    // 刷新抽奖次数
                    this.getDrawCount();
                    if (!res) {
                        this.$emit(EVENT_NAME.DRAW_FAIL);
                        return;
                    }

                    const failCount = res.filter((item) => item.prizeId === null).length;
                    const totalCount = res.length;
                    if (failCount === totalCount) {
                        this.$emit(EVENT_NAME.DRAW_FAIL);
                        return;
                    }

                    // 对数组进行排序，将失败的奖品（prizeId 为 null）放到最后
                    const sortedRes = [...res].sort((itemA, itemB) => {
                        return (itemA.prizeId === null) - (itemB.prizeId === null);
                    });
                    const coverList = this.getCoverList(sortedRes);

                    // 处理占位符替换，数字补齐为两位数并用 HTML 标签包围
                    let desc = this.multiDrawFailDesc;
                    desc = desc.replace(FAIL_DRAW_COUNT_PLACEHOLDER, this.generateHighlightNumber(failCount));
                    desc = desc.replace(
                        SUCCESS_DRAW_COUNT_PLACEHOLDER,
                        this.generateHighlightNumber(totalCount - failCount)
                    );

                    this.multiDrawFailResult = {
                        title: this.multiDrawFailTitle,
                        desc,
                        btnLabel: this.multiDrawFailBtnLabel,
                        btnUrl: this.multiDrawFailBtnUrl,
                        coverList
                    };
                    this.showMultiFailPrizeModal();
                }
            };
        }
    },
    watch: {
        drawCount: {
            handler(newValue) {
                // 透出fego变量
                const currentName = this.currentCountName;
                const remainName = this.remainCountName;
                variable.data[currentName] = newValue.current;
                variable.data[remainName] = newValue.remain;
            },
            deep: true // 开启深度监听
        }
    },
    mounted() {
        if (window.FEGORender && isLogin) {
            this.getDrawCount();
        }
    },
    methods: {
        async getDrawCount() {
            const params = [];
            this.actConfig.forEach((config) => {
                config.appGroup.forEach((item) => {
                    params.push({
                        act_sign: config.actSign,
                        app_key: item.appKey,
                        group: item.group
                    });
                });
            });
            if (!params.length) {
                return;
            }

            const { request } = common;
            const commonApiLottery = request.bindCommonApi('lottery2');
            const loading = Toast.loading({
                duration: 0
            });
            try {
                this.drawCountInfo = await commonApiLottery.post(
                    'drawCountInfo',
                    {
                        draw_configs: params
                    },
                    {
                        group: null // 不需要限制请求频次
                    }
                );
                loading.hide();
            } catch (error) {
                loading.hide();
                throw error;
            }
        },
        async draw() {
            const draw_configs = [];
            this.actConfig.forEach((config) => {
                config.appGroup.forEach((item) => {
                    draw_configs.push({
                        act_sign_encode: config.actSignEncode,
                        app_key_encode: item.appKeyEncode,
                        group_encode: item.groupEncode
                    });
                });
            });
            const { request } = common;
            const commonApiLottery = request.bindCommonApi('lottery2');

            let loading = null;
            if (!this.needAnimate) {
                loading = Toast.loading({
                    duration: 0
                });
            }

            try {
                const res = await commonApiLottery.post('draw', {
                    draw_configs,
                    delay: 0
                });
                if (!this.needAnimate) {
                    loading.hide();
                }
                return res;
            } catch (error) {
                if (!this.needAnimate) {
                    loading.hide();
                }
                throw error;
            }
        },
        /**
         * 一键多抽
         */
        async multiDraw() {
            const draw_configs = [];
            this.actConfig.forEach((config) => {
                config.appGroup.forEach((item) => {
                    draw_configs.push({
                        act_sign_encode: config.actSignEncode,
                        app_key_encode: item.appKeyEncode,
                        group_encode: item.groupEncode
                    });
                });
            });
            const { request } = common;
            const commonApiLottery = request.bindCommonApi('lottery2');

            let loading = null;
            if (!this.needAnimate) {
                loading = Toast.loading({
                    duration: 0
                });
            }
            try {
                const availableCount = Math.min(this.multiDrawCount, this.drawCount.remain);
                const list = await commonApiLottery.post('multiDraw', {
                    draw_configs,
                    delay: 0,
                    count: availableCount
                });
                if (!this.needAnimate) {
                    loading.hide();
                }

                return list;
            } catch (error) {
                if (!this.needAnimate) {
                    loading.hide();
                }
                throw error;
            }
        },
        /**
         * 生成带高亮标签的数字字符串
         */
        generateHighlightNumber(number) {
            return `<span class="highlight">${number}</span>`;
        },
        getCoverList(prizeResArr) {
            const coverList = prizeResArr.map((item) => {
                let app = null;
                this.actConfig.some((config) => {
                    app = config.appGroup.find((groupItem) => groupItem.appKey === item.appKey);
                    return app;
                });
                const target = app?.prizeList.find((prizeItem) => prizeItem.prizeKey === item.prizeKey) || {};
                return target.congratImgUrl || this.failCoverUrl;
            });
            return coverList;
        },
        showPrizeModal(target) {
            if (target.useCustomPrizeModal && target.fegoPrizeModel) {
                // 使用fego自定义获奖弹窗
                this.openDialog(target.fegoPrizeModel);
            } else {
                // 默认获奖弹窗
                this.showDrawResultModal = true;
            }
        },
        showMultiPrizeModal() {
            this.showMultiDrawResultModal = true;
        },
        showMultiFailPrizeModal() {
            this.isMultiDrawFailModalShow = true;
        },
        /**
         * 打开fego弹窗
         */
        openDialog(tplId) {
            const {
                behavior: { runBehaviour }
            } = common;
            runBehaviour(this, {
                type: 'operateComponent',
                value: '',
                tplId,
                methodName: 'open'
            });
        },

        /**
         * 抽奖(供交互配置使用)
         */
        lotteryDraw() {
            this.$refs.lottery.draw();
        },
        /**
         * 一键多抽(供交互配置使用)
         */
        lotteryMultiDraw() {
            if (this.needMultiDraw) {
                this.$refs.lottery.multiDraw();
            } else {
                this.$refs.lottery.draw();
            }
        },
        /**
         * 失败弹窗按钮点击
         */
        failModalBtnClick() {
            this.$emit(EVENT_NAME.FAIL_MODAL_BTN_CLICK);
        }
    }
};
</script>

<style lang="less" scoped></style>
